<div [class]="themeName">
  <div class="modal-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <span class="material-icons mr-2 text-white"
        style="font-size: 28px; text-shadow: 1px 1px 2px rgba(0,0,0,0.1);">menu_book</span>
      <h4 class="modal-title text-white font-weight-bold mb-0" id="modal-basic-title" style="letter-spacing: 0.5px;">
        {{ TextRD[0]?.TitleModal }}
      </h4>
    </div>
    <button type="button" class="close text-white opacity-100" aria-label="Close" (click)="closeModal()"
      style="font-size: 2.5rem; font-weight: 300; outline: none;">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="FG">
      <!-- Navigation Tabs -->
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button [hidden]="this.FlagREALITEM === 0" class="nav-link active" id="nav-home-tab" data-bs-toggle="tab"
            data-bs-target="#" type="button" role="tab" aria-controls="nav-home" aria-selected="true"
            (click)="changeType('NDDRealItemFee')">
            Real Item
          </button>
          <button [hidden]="this.FlagCOPY === 0" class="nav-link" id="nav-profile-tab" data-bs-toggle="tab"
            data-bs-target="#" type="button" role="tab" aria-controls="nav-profile" aria-selected="false"
            (click)="changeType('NDDCopyFee')">
            Copy
          </button>
          <button [hidden]="this.FlagFILE === 0" class="nav-link" id="nav-contact-tab" data-bs-toggle="tab"
            data-bs-target="#" type="button" role="tab" aria-controls="nav-contact" aria-selected="false"
            (click)="changeType('NDDFileFee')">
            File
          </button>
        </div>
      </nav>

      <!-- Loading State -->
      <div *ngIf="loading" class="text-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Content -->
      <div *ngIf="!loading" class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">

          <!-- Page Selection Section -->
          <div class="mb-4" *ngIf="type != 'NDDRealItemFee'">
            <label class="form-label">Page Selection</label>

            <div class="form-check">
              <input (change)="onPageChange($event.target.value)" class="form-check-input" type="radio"
                name="flexRadioPage" id="flexRadioAll" value="1" [checked]="allPage" />
              <label class="form-check-label" for="flexRadioAll">
                Select All Pages
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="radio" name="flexRadioPage" id="flexRadioRange"
                (change)="onPageChange($event.target.value)" value="0" [checked]="!allPage" />
              <label class="form-check-label" for="flexRadioRange">
                Specific Page Range
              </label>
            </div>

            <div class="mt-2 ms-4 pl-2">
              <input type="text" class="form-control" formControlName="formControlpage" placeholder="e.g. 1-10, 20"
                (change)="calPageCountAndFee()" />
              <div class="form-text text-muted mt-1">
                Enter page numbers separated by commas (e.g. 1-10, 20, 30, I, V).
              </div>
            </div>
          </div>

          <!-- Quantity Section -->
          <div class="mb-4" *ngIf="type == 'NDDCopyFee'">
            <label class="form-label">{{'Quantity'|translate}}</label>
            <div class="input-group">
              <input min="1" type="number" class="form-control" formControlName="copyCount"
                (change)="calPageCountAndFee()" />
              <span class="input-group-text">copy</span>
            </div>
          </div>

          <!-- Fee Feedback -->
          <div class="mt-4">
            <div *ngIf="Fee!=''"
              class="alert alert-primary d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2"
              role="alert">
              <span class="h5 m-0">
                {{'Fee'|translate}}: <b>{{ Fee|number }} ฿</b>
              </span>
              <small *ngIf="this.type!='NDDFileFee'" class="text-muted">
                {{'Shipping is not included in the offer price.'|translate}}
              </small>
            </div>
          </div>

        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none" (click)="AddToBasket(1)">
      Add to basket
    </button>
    <button type="button" class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none" (click)="AddToBasket(2)">
      Request
    </button>
  </div>
</div>